import styled from "styled-components";
import { Icon, Progress } from "../../../services/visualLibraryService";
import { EPG_VIEWS, TAG_STATUS } from "../../../utils/epgUtil";

export const CatchupEpgStyled = styled.div`
  direction: ${props => props.direction};
`;

export const StaticEpgStyled = styled.div``;

export const LayoutEmptyStyledEPG = styled.div`
  text-align: center;
  padding-top: 8%;
  margin-right: 25rem;
`;

export const TimeStyled = styled.div`
  font-size: 1.125rem;
  letter-spacing: 0.39px;
  line-height: 20px;
  direction: ${props => props.direction};
  ${props =>
    props.direction === "rtl"
      ? props.view === "static"
        ? "margin-right : 11rem"
        : "margin-right : 12rem"
      : "margin-left : 11rem"};
  text-align: center;
  width: max-content;
  position: absolute;
  height: 100%;
`;

export const TimeRulerStyled = styled.div`
  position: absolute;
  direction: ltr;
  overflow: hidden;
  width: 80rem;
  height: 100%;
  //${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 1rem;
`;

export const DateStyled = styled.div`
  box-sizing: border-box;
  height: 2.625rem;
  width: 11rem;
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  line-height: 2.5rem;
  text-align: center;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
  ${props => (props.direction === "rtl" ? "margin-left" : "margin-right")}: 1rem;
  font-size: 1.125rem;
  direction: ${props => props.direction};
`;

export const NowStyled = styled.div`
  width: 24rem;
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  height: 2.625rem;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  line-height: 2.5rem;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 0.75rem;
  direction: ${props => props.direction};
`;

export const NextStyled = styled.div`
  width: 24rem;
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  height: 2.625rem;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  line-height: 2.5rem;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 0.75rem;
  direction: ${props => props.direction};
`;

export const LaterStyled = styled.div`
  width: 24rem;
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  height: 2.625rem;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  line-height: 2.5rem;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 0.75rem;
  direction: ${props => props.direction};
`;

export const TimeListStyled = styled.ul`
  direction: ${props => props.direction};
  width: max-content;
  list-style: none;
  display: flex;
  ${props => props.direction === "rtl" && "position: relative"};
`;

export const TimeSlotStyled = styled.li`
  height: 2.625rem;
  width: ${props => props.ruler}rem;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  direction: ${props => props.direction};
`;

export const TimesSlotDiv = styled.div`
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  height: 2.625rem;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  line-height: 2.5rem;
`;

export const TimeTextStyled = styled.span`
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 0.75rem;
`;

export const EpgContainer = styled.section`
  margin-top: 4rem;
  position: absolute;
  direction: ${props => props.direction};
  width: 100%;
`;

export const EpgCategories = styled.div``;

export const EpgCategoryContainer = styled.div`
  transform: ${props => props.isGridLoading && "translate(-18%, 400%)"};
`;

export const EpgEventsContainer = styled.div``;

export const CategoriesIconStyled = styled.div``;

export const CategoriesLabelStyled = styled.div``;

export const CategoriesLineStyled = styled.div``;

// export const ImageStyled = styled.image``;

export const ImageStyled = styled.div`
  padding: 0.75rem 0.6875rem;
  height: 100%;
  &.focused {
    border: 0.2rem solid ${props => props.theme.components.epg.border.primaryFocused};
    border-radius: 0.5rem;
  }
`;

export const BackgroundImageStyled = styled.div`
  position: relative;
  margin-bottom: 0.2rem;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.color.greyBlack};
  box-shadow: 4px 0 12px 0 rgba(0, 0, 0, 0.4);
  border-radius: 0.5rem;
  border: 0.2rem solid ${props => props.theme.components.epg.border.default || props.theme.color.greyDark};
  float: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
  &.focused {
    border: 0.2rem solid ${props => props.theme.components.epg.border.focused || props.theme.color.greyLight};
  }
  &:first-child {
    margin-top: 8px;
  }
  ${props => props.isSelected && `background: ${props.theme.color.secondary};`}
`;

export const ImageStyledContainer = styled.div``;
export const ProgramStyled = styled.div`
  ${props => `margin-${props.theme.locale.dir === "rtl" ? "right" : "left"}: 16rem`};
  margin-top: 0.1rem;
  width: 76.8rem;
  overflow: hidden;
`;
export const ProgramListsStyled = styled.ul`
  list-style: none;
  width: max-content;
  position: relative;
`;
export const IconStyled = styled.div`
  position: absolute;
  right: 0;
  background-color: ${props => props.theme.color.primary};
  transform: ${props => (props.theme.locale.dir !== "rtl" ? "scaleX(-1)" : "scaleX(1)")};
  ${props =>
    `${
      props.theme.locale.dir !== "rtl" ? "border-radius: 0.5rem 0 0.125rem 0" : "border-radius: 0 0.5rem 0.125rem 0"
    }`};

  height: 1.3rem;
  width: 1.3rem;
  z-index: 1;
`;

export const IconOverlayStyled = styled(Icon)`
  fill: ${props => props.theme.color.black};
  height: 1rem;
  width: 1rem;
  margin: ${props => (props.theme.locale.dir !== "rtl" ? "0 0 0.2rem 0.2rem" : "0 0.1rem 0 0")};
  ${"" /* &.focused {
    fill: ${props => props.theme.components.epg.icon.focused || props.theme.color.primary};
  } */}
`;
export const ProgramItemsStyled = styled.ul`
  text-decoration: none;
  display: inline-flex;
  //position: absolute;
  direction: ${props => props.direction};
  margin-left: ${props => (props.direction === "rtl" && props.view === "static" ? "6rem" : "0rem")};
  overflow: hidden;
  width: max-content;
  position: relative;
`;

export const ProgramSlot = styled.div`
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
`;

export const ProgramSlotClick = styled.div`
  height: 6.5rem;
  width: ${props => (props.viewType === EPG_VIEWS.dynamic ? `${props.slotWidth}rem` : "24rem")};
`;

export const ProgramSlotStyled = styled.li`
  position: relative;
  text-decoration: none;
  border: 3px solid rgba(209, 211, 212, 0.2);
  border-radius: 0.5rem;
  background-color: ${props => props.theme.color.greyDark};
  direction: ${props => props.direction};

  height: 6.5rem;
  margin-top: 0.6rem;
  text-align: left;
  width: ${props => (props.viewType === EPG_VIEWS.dynamic ? `${props.slotWidth}rem` : "24rem")};
  &.selected {
    border: none;
    border-radius: 0.5rem !important;
    background: ${props => props.theme.color.secondary};
  }
  &.focused {
    border: 0.21rem solid ${props => props.theme.components.epg.border.primaryFocused || props.theme.color.primary};
    border-radius: 0.5rem !important;
  }
`;

export const ProgramInnerContainer = styled.div`
  padding: 1.188rem 1.688rem 0 1.688rem;
`;
export const ProgramTitleStyled = styled.div`
  color: ${props => props.theme.color.white};
  font-size: 1.45rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: ${props => (props.direction === "rtl" ? "2.2rem" : "1.7rem")};
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  direction: ${props => props.direction};
`;

// Channel Row
export const ChannelRowContainer = styled.div`
  display: flex;
  margin-bottom: 0.8rem;
  &:first-child {
    margin-top: 8px;
  }
`;

export const ChannelImageContainer = styled.div`
  height: 6.8rem;
  width: 11rem;
`;

export const ProgramListContainer = styled.div`
  width: 88%;
  overflow: hidden;
  direction: ltr;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  & ul.programsList {
    margin-top: 0.4rem;
  }
  & ul.programsList li {
    position: relative;

    margin-top: 0.1rem;
    overflow: hidden;
  }
`;

export const ProgramDurationStyled = styled.div`
  color: ${props => props.theme.components.epg.color.default || props.theme.color.greyLight};
  font-size: 1.12rem;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
`;

export const StatusWrapper = styled.span`
  color: ${props => (props.status !== TAG_STATUS.live ? props.theme.color.black : props.theme.color.white)};
  font-size: 1.05rem;
  font-weight: 600;
  background: ${props => (props.status !== TAG_STATUS.live ? props.theme.color.white : props.theme.color.danger)};
  padding: 0.2rem;
  letter-spacing: -0.3px;
  line-height: ${props => (props.direction === "rtl" ? "1.5rem" : "1.125rem")};
  border-radius: 0.18rem;
  position: absolute;
  ${props => `${props.direction === "rtl" ? "left" : "right"}: 0.31rem`};
  bottom: 0.31rem;
`;

export const ProgramDurationGradientBarWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const ProgramGradientBar = styled.div`
  margin-left: 0.8rem;
`;

export const ProgressStyled = styled(Progress)`
  margin: 0 0.7rem;
  width: 45%;
  direction: ${props => (props.theme.locale.dir === "rtl" ? "rtl" : "")};
`;

export const BarTimeStyled = styled.div`
  position: absolute;
  top: 0rem;
  ${props => (props.direction === "rtl" ? "right" : "left")}: ${props => props.move}rem;
  width: 0.1rem;
  background-color: ${props => props.theme.components.epg.color.markerColor};
  pointer-events: none;
  z-index: 100;
  height: 100vh;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -0.55rem;
    border-width: 0.6rem;
    border-style: solid;
    border-color: ${props => props.theme.components.epg.color.markerColor} transparent transparent transparent;
  }
`;
